import Order from '@/entity/Order';
/**
 * 지연출력주문 타이머 관리
 */
export default class DelayOrder {
    callback;
    timerId;
    orderData = new Order();
    constructor({ orderData, timerId, callback, } = {
        orderData: new Order(),
        timerId: null,
        callback: () => { },
    }) {
        this.orderData = orderData;
        this.timerId = timerId;
        this.callback = callback;
    }
    setTimerId(timerId) {
        this.timerId = timerId;
    }
}
